import MessageBus from '@/ports-frontend/MessageBus';

export async function loginOpen() {
  MessageBus.publishEvent({
    topic: 'wh.common.command.ui.login.flow.start',
    data: {},
  });
}

type LoginWatcherEvent = {
  type:
    | 'LOGIN_MODAL_STATE_VISIBLE'
    | 'LOGIN_MODAL_STATE_AWAIT_LOGIN'
    | 'LOGIN_MODAL_STATE_CLOSED';
  data: {
    state: 'FORM_VISIBLE' | 'AWAIT_LOGIN' | 'NONE';
  };
};

export async function loginWatcher({
  callback,
}: {
  callback: (event: LoginWatcherEvent) => void;
}) {
  const unsubscribe = await MessageBus.onSubscribe(
    ({ payload }) => {
      switch (payload.state) {
        case 'FORM_VISIBLE': {
          return callback({
            type: 'LOGIN_MODAL_STATE_VISIBLE',
            data: payload,
          });
        }
        case 'AWAIT_LOGIN': {
          return callback({
            type: 'LOGIN_MODAL_STATE_AWAIT_LOGIN',
            data: payload,
          });
        }
        case 'NONE': {
          return callback({
            type: 'LOGIN_MODAL_STATE_CLOSED',
            data: payload,
          });
        }
      }
    },
    ['wh.common.event.ui.login.flow.state.changed']
  );

  return () => unsubscribe();
}
